
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ContactForm from '@/components/ContactForm';
import SEO from '@/components/SEO';

// Import refactored components
import HeroSection from './HeroSection';
import ServiceDescription from './ServiceDescription';
import ProcessSection from './ProcessSection';
import WhyChooseSection from './WhyChooseSection';

const ProjectConsulting: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Project Consulting Services"
        description="Strategic IT guidance to align technology with your business objectives and drive growth. Expert consulting for small to medium businesses."
        canonicalUrl="https://itmgmtsol.com/services/project-consulting"
      />
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Service Description Section */}
      <ServiceDescription />
      
      {/* Why Choose Us Section */}
      <WhyChooseSection />
      
      {/* Process Section */}
      <ProcessSection />
      
      <ContactForm />
      <Footer />
    </div>
  );
};

export default ProjectConsulting;
